export default __webpack_public_path__ + "static/media/Budget-Tracker-PWA-img-2.e4936ed4.gif";